import { Box, Grid } from '@mui/material';

import theme from 'theme';
import VacationRequestsTable from './VacationRequestsTable';

const VacationsView = () => (
  <Box sx={{ padding: theme.spacing(4) }}>
    <Grid container spacing={4}>
      <Grid
        size={{
          lg: 12,
          md: 12,
          xl: 12,
          xs: 12,
        }}
      >
        <VacationRequestsTable />
      </Grid>
    </Grid>
  </Box>
);

export default VacationsView;
